/**
 * Button Component Entry Point
 *
 * Re-exports the `Button` component and its props for easier imports.
 * This allows consumers to import from the component directory directly:
 *
 * Example:
 * import { Button, ButtonProps } from "@geekyhawks/react-native-ui-components";
 *
 * Author: Geeky Hawks FZE LLC
 */

export { default as Button } from "./Button";
export type { Props as ButtonProps } from "./Button";
